import React from "react";
import { Textarea, TextareaProps } from "@fluentui/react-components";

import { useAutosizeTextarea } from "@/hooks/use-autosize-textarea";

export interface AutosizeTextareaProps extends TextareaProps {}

export function AutosizeTextarea({ value, style, ...props }: AutosizeTextareaProps) {
  const ref = useAutosizeTextarea(value);
  return <Textarea ref={ref} resize="none" value={value} style={{ ...style, overflow: "hidden" }} {...props} />;
}
